import React from "react";
import { createPortal } from "react-dom";
import styles from "./style.module.scss";

const LoadingScreen = (props) => {
  const { isLoading } = props;

  return (
    <>
      {isLoading && createPortal(
        <div className={styles.overlay}>
          <div className={styles.lds_roller}>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
        , document.body)
      }
    </>
  );
}

export default LoadingScreen;